const CONFIG = {
  quality: 0.9,
  targetRatio: 0.85,
  maxWidth: 800,
  maxHeight: 800,
  qualityStep: 0.1,
  minQuality: 0.1,
} as const;

const convertImageToJpg = (
  blob: Blob,
  quality: number,
  maxWidth: number,
  maxHeight: number,
): Promise<Blob> =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(blob);

    img.onload = () => {
      const scale = Math.min(maxWidth / img.width, maxHeight / img.height, 1);

      const canvas = document.createElement('canvas');
      canvas.width = img.width * scale;
      canvas.height = img.height * scale;

      const ctx = canvas.getContext('2d');
      if (!ctx) return reject('Canvas no disponible');

      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(
        (jpeg) => {
          URL.revokeObjectURL(url);
          jpeg ? resolve(jpeg) : reject('Error JPEG');
        },
        'image/jpeg',
        quality,
      );
    };

    img.onerror = () => reject('Error cargando imagen');
    img.src = url;
  });

export const compressImg = async (blob: Blob): Promise<Blob> => {
  if (!blob.type.startsWith('image/')) return blob;

  let quality = CONFIG.quality;
  let result = blob;
  const targetSize = blob.size * CONFIG.targetRatio;

  while (quality >= CONFIG.minQuality && result.size > targetSize) {
    result = await convertImageToJpg(blob, quality, CONFIG.maxWidth, CONFIG.maxHeight);
    quality -= CONFIG.qualityStep;
  }

  return result;
};
